import * as yup from 'yup';

import { z } from 'zod';

export const contactSchema = yup.object().shape({
  userName: yup
    .string()
    .required('Please enter your name.')
    .max(50, 'Name should be within 50 digit.')
    .matches(/^[a-zA-Z ]*$/, 'Name should be in alphabetic order.')
    .test('checkNullValues', 'Please type your name.', function (values: any) {
      // console.log('name', values.replace(/\s+/g, ''));
      if (values.replace(/\s+/g, '').length > 0) {
        return true;
      } else {
        return false;
      }
    }),
  userPhone: yup
    .string()
    .max(20, 'Phone number should be within 20 digit.')
    .test('contactInfo', 'Please enter phone number', function (values: any) {
      const { contact } = this.parent;
      if (contact === 'phone') {
        if (values.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }),
  userEmail: yup
    .string()
    .email('Please enter valid email.')
    .test('contactInfo', 'Please enter email address.', function (values: any) {
      const { contact } = this.parent;
      if (contact === 'email') {
        if (values.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }),
  contact: yup.string(),
});

export const billSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'This field has to be filled.' })
    .regex(/^[a-zA-Z ]*$/, 'Name should be in alphabetic order'),
  contactType: z.enum(['email', 'phone']),
  userEmail: z
    .string()
    .min(1, { message: 'This field has to be filled.' })
    .email('This is not a valid email.')
    .optional(),
  userPhone: z
    .string()
    .min(10, { message: 'Phone no is too short' })
    .max(14, { message: 'Phone no is too long' })
    .optional(),
  pay_with_cash: z.boolean().default(false),
});
// .superRefine((data, ctx) => {
//   console.log(data);
//   if (data.contactType === 'email' && data.userEmail === '') {
//     ctx.addIssue({
//       code: z.ZodIssueCode.custom,
//       message: 'Please enter email address',
//       path: ['userEmail'],
//     });
//   }
//   if (data.contactType === 'phone' && data.userPhone === '') {
//     ctx.addIssue({
//       code: z.ZodIssueCode.custom,
//       message: 'Please enter phone number',
//       path: ['userPhone'],
//     });
//   }
// });

type BillSchema = z.infer<typeof billSchema>;

const schema = z
  .object({
    subject: z.number().default(0),
    role: z.object({
      owner: z.number(),
      stranger: z.number(),
    }),
  })
  .refine((data) => data.subject !== 1 || (data.subject === 1 && data.role), {
    message: 'Role field is required when subject equals 1',
    path: ['role'], // Pointing out which field is invalid
  });

export const couponSchema = z.object({
  coupon_code: z
    .string()
    .min(1, { message: 'This field has to be filled.' })
    .regex(/^[a-zA-Z]+$/, 'Coupon should be in alphabetic order'),
});
